const useTokenDataFromCallbackPage = () => {
  const tokenData = window.location.search.substr(6);
  return tokenData;
};

export default useTokenDataFromCallbackPage;
